import resize from "../resize";
import Swiper, { Navigation, Pagination, Lazy } from "swiper";
Swiper.use([Pagination, Navigation, Lazy]);

const initEducatorsSlider = () => {
  const slider = document.querySelector(".educators-slider");
  let swiper = null;

  function init() {
    if (!swiper) {
      swiper = new Swiper(slider, {
        autoHeight: false,
        loop: true,
        spaceBetween: 20,
        slidesPerView: 1.3,
        pagination: {
          el: ".educators-pagination",
          type: "fraction",
        },
      });
    }
  }

  function destroy() {
    if (swiper) {
      swiper.destroy();
      swiper = null;
    }
  }

  function resizeSwiper() {
    window.innerWidth <= 600
      ? init()    
      : destroy();
  }

  if (document.querySelectorAll(".educators-item").length > 1) {
    resizeSwiper();
    resize(resizeSwiper);
  }
};

export default initEducatorsSlider;
